module.exports = __webpack_public_path__ + "static/img/logo-dock619.96d707f5.png";